export var PROFILE_UI_TRANSLATIONS_KEY = 'profile-ui-translations-key';